import React from 'react';
import IPAddressInfo from '../ip-address-info';

type IPAddressProps = {
  ips: string[];
};

function IPAddress({ips}: IPAddressProps) {
  return (
    <div className={'px-[10px] py-[13px] border-b border-b-[#e9eced]'}>
      <h5 className={'text-xs m-0 text-[#9fa1a4] mb-1 flex items-center'}>
        IP位置
        <IPAddressInfo />：
      </h5>
      {ips?.map((ip, idx) => {
        return (
          <p className={'m-0 mb-[5px]'} key={idx} data-test-id={'ip-address'}>
            {ip}
          </p>
        );
      })}
    </div>
  );
}

export default IPAddress;
